import {Component, ElementRef, inject, viewChild} from '@angular/core';
import {NgClass} from "@angular/common";
import {NotificationComponent} from "src/app/presentation/main-view/notifications/notification/notification.component";
import {ViewportService} from "src/app/infrastructure/viewport.service";
import {NotificationsStore} from 'src/app/presentation/main-view/notifications/notifications.store';
import {NotificationsService} from 'src/app/presentation/main-view/notifications/notification.service';
import {AssetsStore} from 'src/app/domain/assets/assets.store';

@Component({
  selector: 'app-notifications',
  imports: [
    NotificationComponent,
    NgClass
  ],
  templateUrl: './notifications.component.html',
  styleUrl: './notifications.component.css'
})
export class NotificationsComponent {

  deleted = false;

  assetsStore = inject(AssetsStore);
  notificationsStore = inject(NotificationsStore);

  private readonly el = viewChild.required<ElementRef<HTMLDivElement>>('notificationsWrapper');

  constructor(
    protected viewportService: ViewportService,
    private readonly notificationService: NotificationsService
  ) {
    this.notificationService.loadNotifications();
  }

  dismissAll() {
    if (confirm("Are you sure you want to dismiss all notifications?")) {
      this.deleted = true;
      this.el().nativeElement.addEventListener('transitionend', () => {
        const notifications = this.notificationsStore.entities();
        notifications.forEach(notification => this.notificationService.dismissNotification(notification));
      });
    }
  }
}
